import * as React from 'react';
import { Map, TileLayer } from 'react-leaflet';
import { connect } from 'react-redux';
import { getMarkerHtml,osmURL, mapBounds, maxZoom, minZoom, mapOptions,generateIconHelperData} from '../Map/MapHelpers/MapHelpers';
import * as MapModule from 'Modules/MapModule';
import { RootState } from 'Redux/Reducers/_RootReducer';
import { Polyline, Marker, Popup } from 'react-leaflet';
import {HistoryCollisionSelectors} from 'Redux/Selectors/CollisionSelectors'
import {CarSpeedDataframeDto} from '../../Models/CollisionModel'
import * as L from 'leaflet';
import { CarCategory, VehicleSpeedEnum } from 'Models/EnumTypes/VehicleEnumTypes';

export type ConnectedProps = {
    mapStore: MapModule.Types.MapStore;
    ridePath:Array<any>,
    activeSpeedDataframe:CarSpeedDataframeDto
};
export type DispatchedProps = {
    setMapZoom: Function;
};
export type Props = {
    match: any;
};

export class CollisionMap extends React.Component<any,any> {

    private onZoomEnd = (zoomObj) => {
        this.props.setMapZoom(zoomObj.target._zoom);
    }

    public render() {
        const {mapStore} = this.props;

        const iconHelper = generateIconHelperData(CarCategory.PASSENGER_CAR, VehicleSpeedEnum.GREEN);
        const html = `<img style="transform: rotate(0deg)" src="${iconHelper.imageUrl}">`;
        const Icon = L.divIcon({
            iconUrl: iconHelper.imageUrl,
            iconSize: iconHelper.imageSize,
            html,
            className: `vehicle-icon vehicle-icon__${VehicleSpeedEnum.GREEN.toLowerCase()}`
        });

        return  <div className={'CollisionMap'}>
                    <Map
                        center={mapStore.center}
                        zoom={mapStore.zoom}
                        options={mapOptions}
                        onZoomEnd={this.onZoomEnd}
                        maxZoom={maxZoom}
                        minZoom={minZoom}
                        zoomControl={false}
                        maxBounds={mapBounds}
                    >
                        <TileLayer url={osmURL} />
                        <Polyline className={'todays_polyline'} positions={this.props.ridePath} />
                        {
                            this.props.activeSpeedDataframe && 
                            <Marker
                                position={{
                                    lat: this.props.activeSpeedDataframe.latitude,
                                    lng: this.props.activeSpeedDataframe.longitude
                                }}
                                icon={Icon}
                            />
                        }
                    </Map>
                </div>
    }
}

function mapStateToProps(state: RootState): ConnectedProps {
    return {
        mapStore: state.mapStore,
        ridePath:HistoryCollisionSelectors.getRidePath(state),
        activeSpeedDataframe:HistoryCollisionSelectors.getActiveSpeedDataframe(state)
    };
}

function mapDispachToProps(dispatch: any): DispatchedProps {
    return {
        setMapZoom: (zoom: number) => dispatch(MapModule.Actions.setMapZoom(zoom)),
    };
}

export default connect(
    mapStateToProps,
    mapDispachToProps
)(CollisionMap);



// WEBPACK FOOTER //
// ./src/components/History/CollisionMap.tsx